/**
 * Detección de plataforma (reglas Apple-safe).
 *
 * isIOSApp(): true SOLO dentro del binario iOS nativo (Capacitor).
 *   En web (Safari/Chrome) y en Android nativo → false.
 *   Se usa para ocultar TODA ruta de compra/checkout/precio en iOS,
 *   donde Apple exige IAP para contenido digital. El cobro de la
 *   suscripción del distribuidor ($25/mes) ocurre por WEB, fuera de iOS.
 */
export const isIOSApp = () => {
  if (typeof window === 'undefined') return false;
  const cap = window.Capacitor;
  return !!(cap?.isNativePlatform?.() && cap?.getPlatform?.() === 'ios');
};
